import { ThemesActions } from '@insync-students-constants/Themes';
import { ThemeState, IThemesState, ReducerAction } from './ThemeContext.types';

/**
 * themesReducer
 * @param {IThemeState}         state      - Current  Context state
 * @param {ReducerAction}       action     - Object with action to do and data to update
 */
export const themesReducer = (state: IThemesState, action: ReducerAction) => {
  switch (action.type) {
    case ThemesActions.UPDATE_CURRICULA_SELECTED:
      {
        return {
          ...state,
          theme: {
            ...state.theme,
            selected: action.payload
          } as ThemeState
        };
      }
    default:
      {
        throw new Error(`Unhandled action type: ${action.type}`);
      }
  }
};